/** The parts that scope a persisted dimension selection to one user. */
export interface DimensionScopeKeyParts {
  clientId: string;
  userId: string;
  /**
   * The active dimension's `name`, read verbatim off
   * `/me.accessControl.dimensions[0]` — see `accessDimensionQueryParam.ts`.
   */
  dimensionName: string;
}

export const STORAGE_KEYS = {
  clientId: 'encore.clientId',

  /**
   * Key for a persisted dimension-value selection (DP-3188), scoped per
   * client + user + dimension so no selection can bleed across any of them.
   *
   * `userId` must be the personnel entity id — read it as
   * `useCurrentUser().userId`, which resolves `data.entityData.id`; there is no
   * `data.id` sibling on the response. It is present once `/me` succeeds, and
   * never the Auth0
   * `UserContext` identity, whose `'unknown'` fallback would collapse
   * distinct users onto one key. Callers resolve all three parts before the
   * gate runs, so none of them is ever empty.
   */
  dimensionScope: ({
    clientId,
    userId,
    dimensionName,
  }: DimensionScopeKeyParts): string =>
    `encore.dimensionScope.${clientId}.${userId}.${dimensionName}`,
} as const;
